import React from 'react';

import { Icon } from './styles';

export interface BadgeName {
  id?: string;
  name?: string;
  lastName?: string;
}

interface Props {
  isRectangleBox?: boolean;
  textStream?: BadgeName;
  badgeText?: string;
  index?: number;
  lineGroup?: boolean;
}

const Badge = ({ textStream, index, badgeText, lineGroup }: Props) => {
  const getInitials = (badgeName: BadgeName) =>
    badgeName.name && badgeName.lastName
      ? `${badgeName.name.substring(0, 1)}${badgeName.lastName.substring(0, 1)}`
      : '';
  return (
    <>
      {textStream ? (
        <Icon key={textStream.id} index={index} isRectangleBox={lineGroup}>
          {lineGroup ? textStream.name : getInitials(textStream)}
        </Icon>
      ) : (
        <Icon isRectangleBox>{badgeText}</Icon>
      )}
    </>
  );
};

export default Badge;
